import { Platform } from '@/core/Platform';
import { StyleSheet } from '@/core/StyleSheet';

export default StyleSheet.create({
	text: {
		fontFamily: '$fontRegular',
		fontSize: '$sizeRegular',
		fontWeight: '$weightRegular',
		color: '$textColor',
		...Platform.select({
			web: {
				maxWidth: '100%',
				boxSizing: 'border-box',
				display: 'inline',
				whiteSpace: 'pre-wrap',
				wordWrap: 'break-word',
			},
		}),
	},
	...Platform.select({
		web: {
			textOneLine: {
				overflow: 'hidden',
				textOverflow: 'ellipsis',
				whiteSpace: 'nowrap',
			},
			textMultiLine: {
				display: '-webkit-box',
				overflow: 'hidden',
				textOverflow: 'ellipsis',
				WebkitBoxOrient: 'vertical',
			},
		},
	}),
});
